<template>
    <div>
        <router-link :to="url" class="block py-3">
            <div class="flex justify-between items-center">
                <div class="flex items-center">
                    <div>
                        <slot></slot>
                    </div>
                    <div class="ml-2 text-20 font-bold" :class="[textClass]">{{menuTitle}}</div>
                </div>
            </div>
        </router-link>
    </div>
</template>
<script>
export default {
    props: {
        url: { type: String, required: true },
        menuTitle: { type: String, required: true },
        active: { type: Boolean, required: true }
    },
    computed: {
        textClass: function () {
            if (this.active) {
                return 'text-a-red-d62300';
            }
            return 'text-a-brown-502314';
        },
    },
}
</script>
<style lang="scss" scoped>
    .icon-arrow {
        height: 11px;
    }
</style>
